import LayoutApi from "@/libs/LayoutApi";
import {SLOT_TYPES} from "@/config/layoutConfig";

export default function (store) {
  const user = store.getters["user/getUser"];

  window.Echo.private(`camera-round-${user.id}`).listen(".update", async (wsData) => {
    const {message: data} = wsData;
    const {id_layout: layoutId, loop, cameras, delay} = data;
    const layoutApi = new LayoutApi(store);
    const layout = layoutApi.getLayoutDataById(layoutId);

    try {
      const newTab = await layoutApi.addNewTab('Ronda', layoutId);

      if (!newTab.status) return;

      layoutApi.setActiveTab(newTab.id);
      initializeRound(store, layoutApi, newTab.id, layout.grid.length, cameras, loop, delay);
    } catch (error) {
      console.error("Error setting up new tab:", error);
    }
  });
}

function initializeRound(store, layoutApi, tabId, gridLength, cameras, loop, delay) {
  let slotPos = 1;

  store.dispatch('round_command/setRoundCommandStatus', true);
  store.dispatch('round_command/setTabId', tabId);

  for (let i = 0; i < gridLength; i++) {
    setCameraSlot(layoutApi, cameras[i], slotPos++);
  }

  const intervalConfig = {
    tabId,
    layoutApi,
    store,
    slotPos,
    index: gridLength,
    gridLength,
    cameras,
    delay,
    loop
  }
  startInterval(intervalConfig);
}

function startInterval(config) {
  let paused = false;
  let {tabId, layoutApi, store, slotPos, index, gridLength, cameras, delay, loop} = config;

  const intervalId = setInterval(async () => {
    paused = layoutApi.getCurrentTabId() !== tabId;
    store.dispatch('round_command/setPaused', paused);

    if (!layoutApi.checkIfTabExists(tabId)) {
      clearInterval(intervalId);
      store.dispatch('round_command/reset');
      return;
    }

    if (paused) return;

    if (index < cameras.length) {
      if (slotPos > gridLength) slotPos = 1;

      const ignoredSlot = parseInt(store.getters['round_command/getIgnoredSlot']);
      const camera = cameras[index];

      if (ignoredSlot === slotPos) slotPos++;

      setCameraSlot(layoutApi, camera, slotPos);

      slotPos++;
      index++;

      if (loop && index >= cameras.length) {
        index = 0;
        slotPos = 1;
      }
    } else {
      clearInterval(intervalId);
      store.dispatch('round_command/reset');
    }
  }, delay * 1000);
}

function setCameraSlot(layoutApi, camera, slotPos) {
  const slotInfo = {
    name: `cam_${camera.id}`,
    position: slotPos,
    data: {camera},
    slotType: SLOT_TYPES.CAM_LIVE
  };

  layoutApi.setSlot(
    slotInfo.name,
    slotInfo.position,
    slotInfo.data,
    slotInfo.slotType
  );
}
